import { useContext } from 'react';
import { ConfigProvider } from 'antd';
export var usePrefixCls = function (tag, props) {
    var _a;
    if ('ConfigContext' in ConfigProvider) {
        var getPrefixCls = useContext(ConfigProvider.ConfigContext).getPrefixCls;
        return getPrefixCls(tag, props === null || props === void 0 ? void 0 : props.prefixCls);
    }
    else {
        var prefix = (_a = props === null || props === void 0 ? void 0 : props.prefixCls) !== null && _a !== void 0 ? _a : 'ant-';
        return "".concat(prefix).concat(tag !== null && tag !== void 0 ? tag : '');
    }
};
//# sourceMappingURL=usePrefixCls.js.map